import { ActionType } from 'typesafe-actions';

import * as types from './types';
import * as actions from './actions';

export type ExampleAction = ActionType<typeof actions>;

export interface ExampleState {
    readonly counter: number;
}

const initialState: ExampleState = {
    counter: 0
};

/**
 * @param state – предыдущее состояние
 * @param action - действие (объект в котором обязательно есть type)
 * @returns – следующее состояние
 */
function reducer(state: ExampleState = initialState, action: ExampleAction): ExampleState {
    switch (action.type) {
        case types.INCREASE_COUNTER:
            return increaseCounter(state);

        case types.DECREASE_COUNTER:
            return decreaseCounter(state);

        case types.SET_COUNTER:
            return setCounter(state, action);

        case types.CLEAR_COUNTER:
            return clearCounter(state);

        default:
            return state;
    }
}

function increaseCounter(state: ExampleState) {
    return { ...state, counter: state.counter + 1 };
}

function decreaseCounter(state: ExampleState) {
    return { ...state, counter: state.counter + -1 };
}

function setCounter(state: ExampleState, action: any) {
    return { ...state, counter: action.payload };
}

function clearCounter(state: ExampleState) {
    return { ...state, counter: 0 };
}

export default reducer;
